import en from './en.json';
import ar from './ar.json';

const modules = { en, ar }

module.exports = modules
